export abstract class FileDownloadService {
  /**
   * Persist raw bytes as a browser download. Triggers the `a[download]`
   * anchor pattern and revokes the created object URL after the click.
   */
  abstract saveBytes(
    data: Uint8Array,
    filename: string,
    mimeType?: string
  ): void;

  /**
   * Persist a pre-constructed Blob as a browser download.
   */
  abstract saveBlob(blob: Blob, filename: string): void;
}
